import { ReactNode } from 'react';

import styles from '@components/typography/Typography.module.css';

type Props = {
  children: ReactNode;
  className?: string;
};

const BodyCopyItalics = ({ children, className }: Props) => (
  <span className={`${styles.bodyCopyItalics} ${className ?? ''}`}>{children}</span>
);

export default BodyCopyItalics;
